var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8889 0H13.1111C5.86986 0 0 5.86984 0 13.1111V64.0413C0 72.8549 7.14514 80 15.9587 80H64.0413C72.8548 80 80 72.8549 80 64.0413V13.1111C80 5.86984 74.1301 0 66.8889 0ZM35.7112 61.3102C34.6834 61.3102 33.6788 61.2083 32.7122 61.0191C31.4951 60.7745 30.3334 60.3872 29.2386 59.8777V61.9304H20.4338V18.0725H29.6521V32.0017C30.6944 31.5475 31.8038 31.2127 32.9538 31.0001C33.8477 30.8371 34.7707 30.7497 35.7112 30.7497C44.152 30.7497 50.9885 37.5892 50.9885 46.03C50.9885 54.4737 44.1491 61.3102 35.7112 61.3102ZM53.2304 36.7011C48.3535 36.7011 44.3995 32.7471 44.3995 27.8701C44.3995 25.3865 45.4273 23.1358 47.084 21.5373L59.5691 34.0224C57.9589 35.6733 55.7141 36.7011 53.2304 36.7011Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7112 38.9138C35.2774 38.9138 34.8435 38.9517 34.4214 39.0303C33.8856 39.1293 33.379 39.2807 32.8869 39.4932C32.1474 39.8106 31.4864 40.2503 30.9099 40.7831C29.457 42.0962 28.5894 43.9946 28.5894 46.0328C28.5894 48.0563 29.4599 49.9577 30.9099 51.2854C31.4282 51.7658 32.028 52.1705 32.6831 52.4791C33.1985 52.7208 33.7429 52.9013 34.2991 53.012C34.7678 53.1022 35.2395 53.1488 35.7083 53.1488C39.6332 53.1488 42.8272 49.9576 42.8272 46.0328C42.8272 42.1079 39.6361 38.9138 35.7112 38.9138Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb6cd313f83bd642dc76052851cd7f37.svg";
export { ForwardRef as ReactComponent };